import { UtmTagsService } from '@packages/shared/core/user/services';
import { CookiesService } from '@packages/shared/core/common/services';
import { ObservabilitySystem } from '@packages/shared/core/common/observability/interfaces';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { SpanNames } from '@packages/shared/core/common/observability/entities';

export type EverflowAttributionParams = Partial<{
  everflow_transaction_id: string;
}>;

export class EverflowService {
  private readonly DEFAULT_EVERFLOW_OFFER_ID = '1';

  private utmTagsService: UtmTagsService;

  private cookiesService: CookiesService;

  constructor(
    utmTagsService: UtmTagsService,
    cookiesService: CookiesService,
    private readonly observabilitySystem: ObservabilitySystem,
  ) {
    this.utmTagsService = utmTagsService;
    this.cookiesService = cookiesService;
  }

  getAttributionParameters(): EverflowAttributionParams | undefined {
    const span = this.observabilitySystem.startSpan({
      name: SpanNames.TRACK_ANALYTICS_EVERFLOW_ATTRIBUTION_PARAMETERS,
    });
    try {
      const transactionId =
        this.getTransactionIdFromEF() || this.getTransactionIdFromCookies() || this.getTransactionIdFromUtmTags();

      span.succeed();

      return {
        everflow_transaction_id: transactionId,
      };
    } catch (e) {
      const err = normalizeError(e);
      span.fail(err);
    }
  }

  private getTransactionIdFromEF(): string | undefined {
    const utmTags = this.utmTagsService.getUtmTags();
    const offerId = utmTags.oid || this.DEFAULT_EVERFLOW_OFFER_ID;
    return window.EF?.getTransactionId(offerId);
  }

  private getTransactionIdFromCookies(): string | undefined {
    return this.cookiesService.get('everflow_transaction_id');
  }

  private getTransactionIdFromUtmTags(): string | undefined {
    const utmTags = this.utmTagsService.getUtmTags();
    return utmTags._ef_transaction_id;
  }
}
